import React, { useState, useEffect } from 'react';
import DataTable from '../../components/DataTable';
import { contactsAPI, clientsAPI } from '../../lib/api';

const Contacts = () => {
  const [contacts, setContacts] = useState([]);
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchData = async () => {
    setLoading(true);
    try {
      const [contactsRes, clientsRes] = await Promise.all([
        contactsAPI.getAll(),
        clientsAPI.getAll()
      ]);
      setContacts(contactsRes.data);
      setClients(clientsRes.data);
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const getClientName = (clientId) => {
    const client = clients.find(c => c.id === clientId);
    return client?.name || '-';
  };

  const columns = [
    { key: 'name', label: 'Name' },
    { key: 'email', label: 'Email' },
    { key: 'phone', label: 'Phone' },
    { key: 'position', label: 'Position' },
    { key: 'client_id', label: 'Client', render: (val) => getClientName(val) },
  ];

  const formFields = [
    { name: 'name', label: 'Name', required: true, placeholder: 'Contact name' },
    { name: 'email', label: 'Email', type: 'email', placeholder: 'contact@example.com' },
    { name: 'phone', label: 'Phone', placeholder: '+1-555-0000' },
    { name: 'position', label: 'Position', placeholder: 'Job title' },
    {
      name: 'client_id',
      label: 'Client (the company this person belongs to)',
      type: 'select',
      options: clients.map(c => ({ value: c.id, label: c.name })),
    },
  ];

  const handleAdd = async (data) => {
    await contactsAPI.create(data);
    fetchData();
  };

  const handleEdit = async (id, data) => {
    await contactsAPI.update(id, data);
    fetchData();
  };

  const handleDelete = async (id) => {
    await contactsAPI.delete(id);
    fetchData();
  };

  return (
    <DataTable
      title="Contacts"
      description="People who belong to a client company. A contact is a person at a client, not a separate customer."
      data={contacts}
      columns={columns}
      formFields={formFields}
      onAdd={handleAdd}
      onEdit={handleEdit}
      onDelete={handleDelete}
      loading={loading}
    />
  );
};

export default Contacts;
